import React from 'react';
import LoginForm from './LoginForm';
import { Users } from 'lucide-react';

const AuthPage = () => {
  return (
    <div className="flex min-h-screen w-full bg-gray-50">
      {/* Left Side - Branding */}
      <div className="hidden md:flex flex-col justify-between md:w-[35%] lg:w-[45%] bg-accent-indigo p-10 lg:p-16 text-white relative overflow-hidden">
        <div className="relative z-10">
          <div className="flex items-center space-x-3 mb-8">
            <div className="p-2 bg-white/20 rounded-lg backdrop-blur-sm">
              <Users size={32} />
            </div>
            <div>
              <h1 className="text-3xl font-bold tracking-tight">Vet Collab</h1>
              <p className="text-sm text-indigo-100 opacity-80 font-medium">powered by furcare</p>
            </div>
          </div>
          
          <div className="max-w-md mt-12">
            <p className="text-xl leading-relaxed font-light text-indigo-50">
              Connect, collaborate, and advance veterinary medicine together. 
              Join a community of veterinary professionals and students worldwide.
            </p>
          </div>
        </div>

        <div className="relative z-10 text-sm opacity-60">
          © 2026 Tutelage Private Limited. All rights reserved.
        </div>

        {/* Subtle background decoration */}
        <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/2 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 translate-y-1/2 -translate-x-1/2 w-96 h-96 bg-black/10 rounded-full blur-3xl"></div>
      </div>

      {/* Right Side - Login Form */}
      <div className="flex-1 flex items-center justify-center p-6 lg:p-12 relative">
        <div className="md:hidden absolute top-8 left-8 right-8 flex items-center justify-between">
          <div className="flex items-center space-x-2 text-accent-indigo">
            <Users size={28} />
            <span className="font-bold text-2xl tracking-tight">Vet Collab</span>
          </div>
        </div>
        
        <LoginForm />
      </div>
    </div>
  );
};

export default AuthPage;
